import React from 'react';

interface IconProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

export const HomeIcon: React.FC<IconProps> = ({ 
  width = 20, 
  height = 20, 
  fill = "currentColor",
  className 
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    height={height} 
    viewBox="0 -960 960 960" 
    width={width} 
    fill={fill}
    className={className}
  >
    <path d="M240-200h147.69v-235.38h184.62V-200H720v-360L480-741.54 240-560v360Zm-40 40v-420l280-211.54L760-580v420H532.31v-235.38H427.69V-160H200Zm280-310.77Z"/>
  </svg>
);

export const TemplatesIcon: React.FC<IconProps> = ({ 
  width = 20, 
  height = 20, 
  fill = "currentColor",
  className 
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    height={height} 
    viewBox="0 -960 960 960" 
    width={width} 
    fill={fill}
    className={className}
  >
    <path d="M540-600v-200h260v200H540ZM160-480v-320h260v320H160Zm380 320v-320h260v320H540Zm-380 0v-200h260v200H160Zm40-360h180v-240H200v240Zm380 320h180v-240H580v240Zm0-440h180v-120H580v120ZM200-200h180v-120H200v120Zm180-320Zm200-120Zm0 200ZM380-320Z"/>
  </svg>
);

export const PricingIcon: React.FC<IconProps> = ({ 
  width = 20, 
  height = 20, 
  fill = "currentColor",
  className 
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    height={height} 
    viewBox="0 -960 960 960" 
    width={width} 
    fill={fill}
    className={className}
  >
    <path d="M441.54-200v-78.46q-46.92-8.92-79.81-36.77-32.88-27.85-50.81-70.23l58.93-25.23q13.61 29.23 34.5 46.84 20.88 17.62 52.96 17.62 32.84 0 56.03-19.58 23.2-19.57 23.2-56.19 0-30.46-21.31-51.15-21.31-20.7-75.69-43.47-50.54-20.23-82.46-58.65-31.93-38.42-31.93-90.27 0-55.77 33.54-94.38 33.54-38.62 82.85-47.31V-840h40v75.77q39.23 5.61 66 28.27 26.77 22.65 42.15 57.04l-55.38 22.92q-12.16-21.46-30.27-34.58-18.12-13.11-44.97-13.11-29.23 0-48.5 16.19-19.26 16.19-19.26 43.88 0 26.7 18.65 44.12 18.65 17.42 68.58 37.88 53.69 21.84 86.42 60.15 32.73 38.31 32.73 91.16 0 60.31-32.92 98.12-32.93 37.81-82.16 48.04V-200h-40Z"/>
  </svg>
);

export const UploadIcon: React.FC<IconProps> = ({ 
  width = 20, 
  height = 20, 
  fill = "currentColor",
  className 
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    height={height} 
    viewBox="0 -960 960 960" 
    width={width} 
    fill={fill}
    className={className}
  >
    <path d="M460-336.92v-346l-93.23 93.23-28.31-28.77L480-760l141.54 141.54-28.31 28.77L500-682.92v346h-40ZM264.62-200q-27.62 0-46.12-18.5Q200-237 200-264.62v-96.92h40v96.92q0 9.24 7.69 16.93 7.69 7.69 16.93 7.69h430.76q9.24 0 16.93-7.69 7.69-7.69 7.69-16.93v-96.92h40v96.92q0 27.62-18.5 46.12Q723-200 695.38-200H264.62Z"/>
  </svg>
);

export const HideSidebarIcon: React.FC<IconProps> = ({ 
  width = 20, 
  height = 20, 
  fill = "currentColor",
  className 
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    height={height} 
    viewBox="0 -960 960 960" 
    width={width} 
    fill={fill}
    className={className}
  >
    <path d="M623.85-353.08v-253.84L496.15-480l127.7 126.92ZM224.62-160q-26.85 0-45.74-18.88Q160-197.77 160-224.62v-510.76q0-26.85 18.88-45.74Q197.77-800 224.62-800h510.76q26.85 0 45.74 18.88Q800-762.23 800-735.38v510.76q0 26.85-18.88 45.74Q762.23-160 735.38-160H224.62ZM320-200v-560h-95.38q-9.24 0-16.93 7.69-7.69 7.69-7.69 16.93v510.76q0 9.24 7.69 16.93 7.69 7.69 16.93 7.69H320Zm40 0h375.38q9.24 0 16.93-7.69 7.69-7.69 7.69-16.93v-510.76q0-9.24-7.69-16.93-7.69-7.69-16.93-7.69H360v560Zm-40 0H200h120Z"/>
  </svg>
);

export const OpenSidebarIcon: React.FC<IconProps> = ({ 
  width = 20, 
  height = 20, 
  fill = "currentColor",
  className 
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    height={height} 
    viewBox="0 -960 960 960" 
    width={width} 
    fill={fill}
    className={className}
  >
    <path d="M496.15-606.92v253.84L623.85-480l-127.7-126.92ZM224.62-160q-26.85 0-45.74-18.88Q160-197.77 160-224.62v-510.76q0-26.85 18.88-45.74Q197.77-800 224.62-800h510.76q26.85 0 45.74 18.88Q800-762.23 800-735.38v510.76q0 26.85-18.88 45.74Q762.23-160 735.38-160H224.62ZM320-200v-560h-95.38q-9.24 0-16.93 7.69-7.69 7.69-7.69 16.93v510.76q0 9.24 7.69 16.93 7.69 7.69 16.93 7.69H320Zm40 0h375.38q9.24 0 16.93-7.69 7.69-7.69 7.69-16.93v-510.76q0-9.24-7.69-16.93-7.69-7.69-16.93-7.69H360v560Zm-40 0H200h120Z"/>
  </svg>
);

export const LogoutIcon: React.FC<IconProps> = ({ 
  width = 16, 
  height = 16, 
  fill = "currentColor",
  className 
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    height={height} 
    viewBox="0 -960 960 960" 
    width={width} 
    fill={fill}
    className={className}
  >
    <path d="M224.62-160q-27.62 0-46.12-18.5Q160-197 160-224.62v-510.76q0-27.62 18.5-46.12Q197-800 224.62-800h256.15v40H224.62q-9.24 0-16.93 7.69-7.69 7.69-7.69 16.93v510.76q0 9.24 7.69 16.93 7.69 7.69 16.93 7.69h256.15v40H224.62Zm433.84-178.46-28.08-28.77L723.15-460H367.69v-40h355.46l-92.77-92.77 28.08-28.77L800-480 658.46-338.46Z"/>
  </svg>
);

export const AddIcon: React.FC<IconProps> = ({ 
  width = 14, 
  height = 14, 
  fill = "currentColor",
  className 
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    height={height} 
    viewBox="0 -960 960 960" 
    width={width} 
    fill={fill}
    className={className}
  >
    <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"/>
  </svg>
);

export const MoreOptionsIcon: React.FC<IconProps> = ({ 
  width = 18, 
  height = 18, 
  fill = "currentColor",
  className 
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    height={height} 
    viewBox="0 0 32 32" 
    width={width} 
    fill={fill}
    className={className}
  >
    <circle cx="8" cy="16" r="2"></circle>
    <circle cx="16" cy="16" r="2"></circle>
    <circle cx="24" cy="16" r="2"></circle>
  </svg>
);

export const UndoIcon: React.FC<IconProps> = ({ 
  width = 20, 
  height = 20, 
  fill = "currentColor",
  className 
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    height={height} 
    viewBox="0 0 24 24" 
    width={width} 
    fill={fill}
    className={className}
  >
    <path d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"/>
  </svg>
);

export const RedoIcon: React.FC<IconProps> = ({ 
  width = 20, 
  height = 20, 
  fill = "currentColor",
  className 
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    height={height} 
    viewBox="0 0 24 24" 
    width={width} 
    fill={fill}
    className={className}
  >
    <path d="M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"/>
  </svg>
);

export const ActionsIcon: React.FC<IconProps> = ({ 
  width = 16, 
  height = 16, 
  fill = "currentColor",
  className 
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    height={height} 
    viewBox="0 0 24 24" 
    width={width} 
    fill={fill}
    className={className}
  >
    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
  </svg>
);

export const ShareIcon: React.FC<IconProps> = ({ 
  width = 16, 
  height = 16, 
  fill = "currentColor",
  className 
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    height={height} 
    viewBox="0 0 24 24" 
    width={width} 
    fill={fill}
    className={className}
  >
    <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"/>
  </svg>
);

export const MoreVerticalIcon: React.FC<IconProps> = ({ 
  width = 20, 
  height = 20, 
  fill = "currentColor",
  className 
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    height={height} 
    viewBox="0 0 24 24" 
    width={width} 
    fill={fill}
    className={className}
  >
    <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
  </svg>
);

// Material Icons style icons for the exact ag_grid look
export const MoreHorizIcon: React.FC<IconProps> = ({ 
  width = 16, 
  height = 16, 
  fill = "currentColor",
  className 
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    height={height} 
    viewBox="0 0 24 24" 
    width={width} 
    fill={fill}
    className={className}
  >
    <path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
  </svg>
);

export const AutoFixHighIcon: React.FC<IconProps> = ({ 
  width = 16, 
  height = 16, 
  fill = "currentColor",
  className 
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    height={height} 
    viewBox="0 0 24 24" 
    width={width} 
    fill={fill}
    className={className}
  >
    <path d="m20 7 .94-2.06L23 4l-2.06-.94L20 1l-.94 2.06L17 4l2.06.94L20 7zm-2.5 8.5L16 18l2.06.94L19 21l.94-2.06L22 18l-2.06-.94L19 15.5zM12.97 3.5 16 7l1.41-1.41L15.47 3.5 16 3l3 3L16 9l-3-3 1.06-1.06L12.97 3.5zm-2 7L8 13.47l-1.41-1.41L9.47 9.09 9 8.5l-5 5 3 3 5-5-.03-1.09z"/>
  </svg>
);

export const CloseIcon: React.FC<IconProps> = ({ 
  width = 12, 
  height = 12, 
  fill = "currentColor",
  className 
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    height={height} 
    viewBox="0 0 24 24" 
    width={width} 
    fill={fill}
    className={className}
  >
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
  </svg>
); 